const workflowOffsetPattern = /^(\d+)([dhm])$/;
export const MAX_WORKFLOW_OFFSET_DAYS = 365;
const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;
const MAX_WORKFLOW_OFFSET_MINUTES = MAX_WORKFLOW_OFFSET_DAYS * MINUTES_PER_DAY;
export const workflowOffsetMinutes = (amount, unit) => {
    switch (unit) {
        case "d":
            return amount * MINUTES_PER_DAY;
        case "h":
            return amount * MINUTES_PER_HOUR;
        case "m":
            return amount;
    }
};
export const maxWorkflowOffsetAmount = (unit) => MAX_WORKFLOW_OFFSET_MINUTES / workflowOffsetMinutes(1, unit);
export const isWorkflowOffsetFormat = (value) => workflowOffsetPattern.test(value);
export const isWorkflowOffset = (value) => {
    const match = value.match(workflowOffsetPattern);
    if (!match) {
        return false;
    }
    const amount = parseInt(match[1], 10);
    const unit = match[2];
    return workflowOffsetMinutes(amount, unit) <= MAX_WORKFLOW_OFFSET_MINUTES;
};
export const getWorkflowOffset = (offset) => {
    const match = offset.match(workflowOffsetPattern);
    if (match) {
        const days = parseInt(match[1], 10);
        const unit = match[2];
        return [days, unit];
    }
    return [0, "m"];
};
export var WorkflowStatus;
(function (WorkflowStatus) {
    WorkflowStatus["Draft"] = "Draft";
    WorkflowStatus["Published"] = "Published";
})(WorkflowStatus || (WorkflowStatus = {}));
export var WorkflowActorMode;
(function (WorkflowActorMode) {
    WorkflowActorMode["DefaultActor"] = "DefaultActor";
    WorkflowActorMode["AssignedUser"] = "AssignedUser";
})(WorkflowActorMode || (WorkflowActorMode = {}));
//# sourceMappingURL=workflow.js.map